export default __webpack_public_path__ + "static/media/resetPass.9b25b1a8.png";